module.exports = __webpack_public_path__ + "static/img/ponteH_ln298n-1.237e643.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/ponteH_ln298n-1.svg
// module id = 5Alj
// module chunks = 0